import Button from './Button';

export default Button;



// WEBPACK FOOTER //
// ./src/client/Components/Button/index.js